import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { defineLocale } from "ngx-bootstrap/chronos";
import { deLocale } from "ngx-bootstrap/locale";
import { routing, appRoutingProviders } from "./app.routing";
import { HttpClientModule } from "@angular/common/http";
import { ReactiveFormsModule } from "@angular/forms";
import { FormsModule } from "@angular/forms";

defineLocale("de", deLocale);

//Modules
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { SharedModule } from "./shared/shared.module";
import { PagesModule } from "./pages/pages.module";
import { AuthModule } from "./auth/auth.module";

//Services
import { ResponsiveService } from "./services/responsive.service";
import { AuthService } from "./services/auth.service";

// Providers
import { interceptorProviders } from './services/interceptors/interceptors';

//Components
import { AppComponent } from "./app.component";

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    routing,
    BrowserModule,
    BsDatepickerModule.forRoot(),
    BrowserAnimationsModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
    PagesModule,
    AuthModule,
  ],
  providers: [
    ResponsiveService, 
    AuthService, 
    appRoutingProviders, 
    interceptorProviders
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
